export const schoolModeActionTypes = {
  ENABLE_SCHOOL_MODE: 'enableSchoolMode',
};
